import React from 'react';
import { useWebViewAuth } from 'src/services/Auth/hooks/use-webview-auth';

/**
 * Component to initialize WebView authentication
 * 
 * This component doesn't render anything visible,
 * it just sets up the WebView auth listeners and
 * requests authentication when necessary
 */
export const WebViewAuthInitializer: React.FC = () => {
  // Initialize WebView authentication
  useWebViewAuth();
  
  // This component doesn't render anything
  return null;
};
